import { render, staticRenderFns } from "./dimension-edit.vue?vue&type=template&id=eca5acda&scoped=true"
import script from "./dimension-edit.vue?vue&type=script&lang=ts"
export * from "./dimension-edit.vue?vue&type=script&lang=ts"
import style0 from "./dimension-edit.vue?vue&type=style&index=0&id=eca5acda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca5acda",
  null
  
)

export default component.exports